// OAuth配置
export default {
  access_token_url: process.env.VUE_APP_OAUTH_TOKEN_URL || '/oauth/access_token',
  clientId: process.env.VUE_APP_OAUTH_CLIENT_ID || 'test',
  clientSecret: process.env.VUE_APP_OAUTH_CLIENT_SECRET || '36f028580bb02cc8272a9a020f4200e346e276ae664e45ee80745574e2f5ab80',
  scope: process.env.VUE_APP_OAUTH_SCOPE || 'test',
}; 